import { differenceInHours } from 'date-fns';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { updateUserStatus } from '../../../actions/userStatus';
import { subscribeUsersStatus, unsubscribeUsersStatus } from '../../../actions/wsStatus';
import { usersStatusSelector } from '../../../selectors';

const ONE_MINUTE = 60000;

export const useUserStatus = (userId: number) => {
  const usersStatus = useSelector(usersStatusSelector);

  const dispatch = useDispatch();

  const companionUserStatus = React.useMemo(() => {
    return userId && usersStatus ? usersStatus[userId] : null;
  }, [userId, usersStatus]);

  const companionStatus = React.useMemo(() => {
    return companionUserStatus ? companionUserStatus.statusDiffStr : '';
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [companionUserStatus?.statusDiffStr]);

  const lastActionDatetime = React.useMemo(() => {
    return companionUserStatus ? companionUserStatus.lastActionDatetime : '';
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [companionUserStatus?.lastActionDatetime]);

  const refreshUserStatus = () => {
    dispatch(updateUserStatus({ userId }));
  };

  React.useEffect(() => {
    if (userId) {
      dispatch(subscribeUsersStatus([userId]));
    }

    return () => {
      if (userId) {
        dispatch(unsubscribeUsersStatus([userId]));
      }
    };
  }, [userId, dispatch]);

  React.useEffect(() => {
    const hoursNumber = differenceInHours(new Date(), new Date(lastActionDatetime), { roundingMethod: 'floor' });
    let timerId: NodeJS.Timer;

    // Если юзер не в сети меньше часа, обновляем ежеминутно статус
    if (hoursNumber < 1) {
      timerId = setInterval(refreshUserStatus, ONE_MINUTE);
    }

    return () => {
      clearTimeout(timerId);
    };
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [lastActionDatetime]);

  return { companionStatus };
};
